import * as React from "react";
import { useLocation } from "react-router-dom";
import { PRODUCT_PAGES, productPath } from "../seo/productPages";
import { useContent } from "../hooks/useContent";
import { serviceItem, deckItem, deckOrderItem } from "./catalog";
import { track, startAnalytics } from "./track";

/** Просмотры страниц и товаров.
 *
 *  Снипеты рекламных площадок считают ровно один PageView — при загрузке
 *  документа. Сайт же одностраничный: переходы на /decks, /reading, /cards/:deck
 *  идут через роутер без перезагрузки, поэтому просмотры шлём отсюда, а
 *  стартовый PageView у самих снипетов отключён (см. providers.ts). */
export function useRouteAnalytics(): void {
  const { pathname } = useLocation();
  const { data: content } = useContent();

  React.useEffect(() => {
    startAnalytics();
  }, []);

  React.useEffect(() => {
    track({ name: "page_view", path: pathname });
  }, [pathname]);

  React.useEffect(() => {
    if (!content) return;
    // React Router renders "/guidance/" via the "/guidance" route, but
    // useLocation().pathname keeps the trailing slash — normalize the same
    // way App.js's isScenePath does, so pasted/hand-typed links still match.
    const normalized = pathname.replace(/\/+$/, "") || "/";
    const spec = PRODUCT_PAGES.find((p) => productPath(p) === normalized);
    if (!spec) return;

    const item =
      spec.kind === "service"
        ? serviceItem(content, spec.key)
        : spec.kind === "deck"
          ? deckItem(content, spec.key)
          : deckOrderItem(content, "mediumship,guidance");
    if (!item) return;

    track({ name: "view_content", ...item });
  }, [pathname, content]);
}
